import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { lazy } from "react";
import ErrorPage from "./ErrorPage";
import DefaultLayout from "./layouts/DefaultLayout";
import QuickStartLayout from "./layouts/QuickStartLayout";
const ABTest = lazy(() => import("./forms/abtest"));
const ABTests = lazy(() => import("./forms/abtests"));
const Account = lazy(() => import("./forms/account"));
const Accounts = lazy(() => import("./forms/accounts"));
const Automation = lazy(() => import("./forms/automation"));
const AutomationDashboard = lazy(
  () => import("./forms/automationDashboard")
);
const JourneyPlanner = lazy(() => import("./forms/journeyPlanner"));
const AutomationList = lazy(() => import("./forms/automationList"));
const Blacklist = lazy(() => import("./forms/blacklist"));
const Campaign = lazy(() => import("./forms/campaign"));
const Campaigns = lazy(() => import("./forms/campaigns"));
const Communication = lazy(() => import("./forms/communication"));
const Communications = lazy(() => import("./forms/communications"));
const CommunicationActivity = lazy(
  () => import("./forms/communicationActivity")
);
const CommunicationActivities = lazy(
  () => import("./forms/communicationActivities")
);
const CommunicationAudience = lazy(
  () => import("./forms/communicationAudience")
);
const CommunicationAudiences = lazy(
  () => import("./forms/communicationAudiences")
);
const CommunicationAudit = lazy(
  () => import("./forms/communicationAudit")
);
const CommunicationSettings = lazy(
  () => import("./forms/communicationSettings")
);
const Competition = lazy(() => import("./forms/competition"));
const Competitions = lazy(() => import("./forms/competitions"));
const CompetitionStage = lazy(
  () => import("./forms/competitionStage")
);
const CompetitionStages = lazy(
  () => import("./forms/competitionStages")
);
const Contact = lazy(() => import("./forms/contact"));
const Contacts = lazy(() => import("./forms/contacts"));
const ContactAudit = lazy(() => import("./forms/contactAudit"));
const CustomerAddress = lazy(() => import("./forms/customerAddress"));
const DataImport = lazy(() => import("./forms/dataImport"));
const DataImports = lazy(() => import("./forms/dataImports"));
const DataModel = lazy(() => import("./forms/dataModel"));
const DataModels = lazy(() => import("./forms/dataModels"));
const EventProfile = lazy(() => import("./forms/eventProfile"));
const EventProfiles = lazy(() => import("./forms/eventProfiles"));
const EntityAudits = lazy(() => import("./forms/entityAudits"));
const Fixture = lazy(() => import("./forms/fixture"));
const Fixtures = lazy(() => import("./forms/fixtures"));
const FixtureGrade = lazy(() => import("./forms/fixtureGrade"));
const FixtureGrades = lazy(() => import("./forms/fixtureGrades"));
const Help = lazy(() => import("./forms/help"));
const Home = lazy(() => import("./Home"));
const MarketingList = lazy(() => import("./forms/marketingList"));
const MarketingLists = lazy(() => import("./forms/marketingLists"));
const NotFound = lazy(() => import("./NotFound"));
const Opponent = lazy(() => import("./forms/opponent"));
const Opponents = lazy(() => import("./forms/opponents"));
const OpponentType = lazy(() => import("./forms/opponentType"));
const OpponentTypes = lazy(() => import("./forms/opponentTypes"));
const Page = lazy(() => import("./forms/page"));
const QuickStart = lazy(() => import("./forms/quickStart"));
const Report = lazy(() => import("./forms/report"));
const Search = lazy(() => import("./forms/search"));
const Settings = lazy(() => import("./forms/settings"));
const Season = lazy(() => import("./forms/season"));
const Seasons = lazy(() => import("./forms/seasons"));
const SeasonalPeriod = lazy(() => import("./forms/seasonalPeriod"));
const SeasonalPeriods = lazy(() => import("./forms/seasonalPeriods"));
const Sitemap = lazy(() => import("./forms/sitemap"));
const SubscriptionGroup = lazy(
  () => import("./forms/subscriptionGroup")
);
const SubscriptionGroups = lazy(
  () => import("./forms/subscriptionGroups")
);
const Team = lazy(() => import("./forms/team"));
const Teams = lazy(() => import("./forms/teams"));
const TicketHospitalityProduct = lazy(
  () => import("./forms/ticketHospitalityProduct")
);
const TicketHospitalityProducts = lazy(
  () => import("./forms/ticketHospitalityProducts")
);
const Type = lazy(() => import("./forms/type"));
const Types = lazy(() => import("./forms/types"));
const VenueStatus = lazy(() => import("./forms/venueStatus"));
const VenueStatuses = lazy(() => import("./forms/venueStatuses"));
const WarehouseSettings = lazy(() => import("./forms/warehouseSettings"));
const WarehouseApplications = lazy(
  () => import("./forms/warehouseApplications")
);
const WarehouseApplication = lazy(
  () => import("./forms/warehouseApplication")
);

function Routing() {
  const getRouter = () => {
    return createBrowserRouter(
      createRoutesFromElements(
        <>
          <Route path="/" element={<Home />} />
          <Route
            errorElement={<ErrorPage />}
            element={<QuickStartLayout />}
          >
            <Route path="/quick-start" element={<QuickStart />} />
          </Route>
          <Route
            errorElement={<ErrorPage />}
            element={<DefaultLayout />}
          >
            <Route path="/abtest" element={<ABTest />} />
            <Route path="/abtests" element={<ABTests />} />
            <Route path="/account" element={<Account />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route
              path="/automation"
              element={<Automation />}
            />
            <Route
              path="/automation-dashboard"
              element={<AutomationDashboard />}
            />
            <Route
              path="/journey-planner"
              element={<JourneyPlanner />}
            />
            <Route
              path="/automation-list"
              element={<AutomationList />}
            />
            <Route path="/blacklist" element={<Blacklist />} />
            <Route
              path="/reporting-campaign"
              element={<Campaign />}
            />
            <Route
              path="/reporting-campaigns"
              element={<Campaigns />}
            />
            <Route
              path="/email-communication"
              element={<Communication />}
            />
            <Route
              path="/email-communications"
              element={<Communications />}
            />
            <Route
              path="/communication-activity"
              element={<CommunicationActivity />}
            />
            <Route
              path="/communication-activities"
              element={<CommunicationActivities />}
            />
            <Route
              path="/audience"
              element={<CommunicationAudience />}
            />
            <Route
              path="/audiences"
              element={<CommunicationAudiences />}
            />
            <Route
              path="/communication-audit"
              element={<CommunicationAudit />}
            />
            <Route path="/data-import" element={<DataImport />} />
            <Route path="/data-imports" element={<DataImports />} />
            <Route
              path="/communication-settings"
              element={<CommunicationSettings />}
            />
            <Route path="/competition" element={<Competition />} />
            <Route path="/competitions" element={<Competitions />} />
            <Route
              path="/competition-stage"
              element={<CompetitionStage />}
            />
            <Route
              path="/competition-stages"
              element={<CompetitionStages />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/contact-audit" element={<ContactAudit />} />
            <Route
              path="/customer-address"
              element={<CustomerAddress />}
            />
            <Route path="/data-model" element={<DataModel />} />
            <Route path="/data-models" element={<DataModels />} />
            <Route path="/event-profile" element={<EventProfile />} />
            <Route
              path="/event-profiles"
              element={<EventProfiles />}
            />
            <Route path="/entity-audits" element={<EntityAudits />} />
            <Route path="/fixture" element={<Fixture />} />
            <Route path="/fixtures" element={<Fixtures />} />
            <Route path="/fixture-grade" element={<FixtureGrade />} />
            <Route
              path="/fixture-grades"
              element={<FixtureGrades />}
            />
            <Route path="/help" element={<Help />} />
            <Route
              path="/static-marketing-list"
              element={<MarketingList />}
            />
            <Route
              path="/static-marketing-lists"
              element={<MarketingLists />}
            />
            <Route path="/opponent" element={<Opponent />} />
            <Route path="/opponents" element={<Opponents />} />
            <Route path="/opponent-type" element={<OpponentType />} />
            <Route
              path="/opponent-types"
              element={<OpponentTypes />}
            />
            <Route path="/search" element={<Search />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/season" element={<Season />} />
            <Route path="/seasons" element={<Seasons />} />
            <Route
              path="/seasonal-period"
              element={<SeasonalPeriod />}
            />
            <Route
              path="/seasonal-periods"
              element={<SeasonalPeriods />}
            />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route
              path="/email-preference-group"
              element={<SubscriptionGroup />}
            />
            <Route
              path="/email-preference-groups"
              element={<SubscriptionGroups />}
            />
            <Route path="/team" element={<Team />} />
            <Route path="/teams" element={<Teams />} />
            <Route
              path="/ticket-hospitality-product"
              element={<TicketHospitalityProduct />}
            />
            <Route
              path="/ticket-hospitality-products"
              element={<TicketHospitalityProducts />}
            />
            <Route path="/type" element={<Type />} />
            <Route path="/types" element={<Types />} />
            <Route path="/venue-status" element={<VenueStatus />} />
            <Route
              path="/venue-statuses"
              element={<VenueStatuses />}
            />
            <Route
              path="/warehouse-settings"
              element={<WarehouseSettings />}
            />
            <Route
              path="/warehouse-applications"
              element={<WarehouseApplications />}
            />
            <Route
              path="/warehouse-application"
              element={<WarehouseApplication />}
            />
            <Route path="/" element={<Home />} />
            <Route path="/page/*" element={<Page />} />
            <Route path="/report/*" element={<Report />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </>
      )
    );
  };

  return <RouterProvider router={getRouter()} />;
}
export default Routing;
